import { get } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  beneficiary () {
    return get(this.covenant, 'dependent.name', this.user.name)
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/form/resources/computed.js